import React, { useEffect } from 'react'
import { useUserDataStore } from '../stateStores/User'
import LoadingSpinner from '../uiV2/common/loading/LoadingSpinner'
import { AuthHelper } from '../auth/AuthHelper'
import { useAuth } from '../auth/AuthContext'
import { Pages } from '../Pages'
import { useNavigate } from 'react-router-dom'

function Logout(): React.JSX.Element {
    const { logout } = useAuth()
    const { clearUserData } = useUserDataStore()
    const navigate = useNavigate()

    useEffect(() => {
        clearUserData()
        // Clear tenant override on logout to prevent it from affecting the next user
        AuthHelper.removeTenantOverrideId()
        ;(async () => {
            try {
                await logout()
            } finally {
                navigate(Pages.Login, { replace: true })
            }
        })()
    }, [logout, clearUserData, navigate])

    return <LoadingSpinner />
}

export default Logout
